import { X } from "react-feather";
import styles from "./complaintsummary.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ComplaintSummary = ({ complaintData, setComplaintData, setLoading, setSnackbarMsg, setSnackbarOpen }) => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [taskExpanded, setTaskExpanded] = useState("panel1");
    const [charsLeft, setCharsLeft] = useState({ description: 200 });
    const [oldData, setOldData] = useState({ description: '' });
    const [newData, setNewData] = useState({ description: '' });
    const [isUpdate, setIsUpdate] = useState(false);

    const { handleSubmit, register, setValue } = useForm();

    const handleChange = (panel) => (event, isTaskExpanded) => {
        setTaskExpanded(isTaskExpanded ? panel : false);
    }

    useEffect(() => {
        if (complaintData) {
            setOldData({ description: complaintData?.description });
            setNewData({ description: complaintData?.description });

            setValue('description', complaintData?.description);

            if (complaintData?.description?.length) {
                setCharsLeft(prev => {
                    return { ...prev, description: 200 - complaintData?.description?.length };
                })
            }
        }
    }, [complaintData, setValue]);

    const onUpdate = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/complaints/" + complaintData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setComplaintData(prev => {
                return { ...prev, description: response.data.data?.description };
            });
        }).catch((error) => {
            setLoading(false);
        });
    }

    useEffect(() => {
        if (oldData) {
            if (oldData?.description === newData?.description) {
                setIsUpdate(false);
            } else {
                setIsUpdate(true);
            }
        }
    }, [newData, oldData]);

    const deleteConfirm = async (itemId) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/files/' + itemId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setComplaintData(prev => {
                let images = prev?.images?.filter(i => i?.id !== itemId);
                return { ...prev, images: images };
            });
        }).catch(error => {
            setLoading(false);
        });
    }

    const fileHandler = async (e) => {
        let extErr = false;
        let sizeErr = false;
        let files = e.target.files;
        let allowedExtensionArr = ".jpg,.png,.jpeg".split(',');

        if (files.length > 0) {
            if (allowedExtensionArr.length > 0) {
                let fileName = files[0].name;
                let fileSize = files[0].size;
                let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
                fileNameExt = '.' + fileNameExt;

                if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
                    extErr = true;
                }

                if (fileSize >= 5242880) {
                    sizeErr = true;
                }
            }
        }

        if (extErr) {
            toast.error("File type is not allowed.");
            return false;
        }

        if (sizeErr) {
            toast.error("File size should not be greater than 5 MB.");
            return false;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);

        let formData = new FormData();
        formData.append("image", files[0]);

        axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/files/upload', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Files uploaded successfully.');

            setComplaintData(prev => {
                let images = response.data.data.concat(prev?.images);
                return { ...prev, images: images };
            });
        }).catch(error => {
            setLoading(false);
        });
    }

    return (<Accordion expanded={taskExpanded === "panel1"} onChange={handleChange("panel1")}>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
        >
            <div className={`${styles.FormAccoHead}`}>
                <p className={`${styles.FormAccoHeadTitle}`}>Request</p>
            </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
            <form onSubmit={handleSubmit(onUpdate)}>
                <div className={`${styles.SummFormFull}`}>
                    <p className={`${styles.SummFormLabel}`}>Complaint Description</p>
                    <textarea name="description" ref={register} className={`${styles.formControlTextArea}`} maxLength={200} onChange={(e) => {
                        setCharsLeft(prev => {
                            return { ...prev, description: 200 - e.target.value?.length };
                        });

                        setNewData(prev => {
                            return { ...prev, description: e.target.value };
                        });
                    }} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("complaint:update") > -1)}></textarea>
                    <p className={`${styles.RemainingText}`}>{charsLeft?.description} {charsLeft?.description > 1 ? "characters" : "character"} remaining</p>
                </div>
                {isUpdate && <div>
                    <button type='submit' className={`${styles.SummaryUpdateBU}`}>Update</button>
                </div>}
            </form>
            <div className={`${styles.BorderDivSumm}`}>
                <p className={`${styles.SummFormLabel}`}>Images</p>
                <div className={`${styles.Row}`}>
                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("complaint:update") > -1 && <div className={`${styles.FileUpDuBUDiv}`}>
                        <label for="file-upload" className={`${styles.UploadLabel}`}>
                            <span>
                                <div className={`${styles.UpIcon}`}>
                                    <img src="/static/img/uploadIMG.svg" alt="" />
                                </div>{" "}
                                Upload Photos
                            </span>
                            <p className={`${styles.UploadText}`}>
                                File size upto 5 MB <br /> JPEG, JPG, PNG file only
                            </p>
                        </label>
                        <input id="file-upload" type="file" onChange={fileHandler} accept={".jpg,.png,.jpeg"} />
                    </div>}
                    {complaintData?.images?.map((item) => {
                        return <div className={`${styles.SummFormSemiHalf}`}>
                            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("complaint:update") > -1 && <button onClick={(e) => deleteConfirm(item?.id)}><X /></button>}
                            <img src={item?.file_public_url} alt="" />
                        </div>
                    })}
                </div>
            </div>
        </AccordionDetails>
    </Accordion>);
}

export default ComplaintSummary;